var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKalenderIkon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 24,
    viewBox: "0 0 23 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M23 3v3H0V3c0-.55.45-1 1-1h2V1c0-.55.45-1 1-1h1c.55 0 1 .45 1 1v1h11V1c0-.55.45-1 1-1h1c.55 0 1 .45 1 1v1h2c.55 0 1 .45 1 1zm-5 11h3v-3h-3v3zm0 4h3v-3h-3v3zm0 4h3v-3h-3v3zm-4-8h3v-3h-3v3zm0 4h3v-3h-3v3zm0 4h3v-3h-3v3zm-4-8h3v-3h-3v3zm0 4h3v-3h-3v3zm0 4h3v-3h-3v3zm-4-8h3v-3H6v3zm0 4h3v-3H6v3zm0 4h3v-3H6v3zm-4-8h3v-3H2v3zm0 4h3v-3H2v3zm0 4h3v-3H2v3zM0 7v16c0 .55.45 1 1 1h21c.55 0 1-.45 1-1V7H0z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKalenderIkon);
export default __webpack_public_path__ + "static/media/kalender-ikon.db9e759a.svg";
export { ForwardRef as ReactComponent };